import {JackpotBetsOptinReminderLogoMrgreenBox} from "./jackpot-bets-optin-reminder-logo.mrgreen.box";

export const JackpotBetsOptinReminderLogoMrgreenCisBox = JackpotBetsOptinReminderLogoMrgreenBox;